import React, { useCallback, useRef } from 'react';

import type { WaypointCallbackArgs } from 'src/app/shared/components/layout/lazy';
import { Waypoint } from 'src/app/shared/components/scroll';

import { useMomentumBarTracking } from '../../hooks/useTracking';

type Props = Readonly<{
	petitionId: string;
}>;

export const MomentumBarScrollPastTracker: React.FC<Props> = ({ petitionId }) => {
	const tracking = useMomentumBarTracking();
	const hasTracked = useRef(false);

	const onPositionChange = useCallback(
		({ currentPosition, previousPosition }: WaypointCallbackArgs) => {
			if (hasTracked.current) {
				return;
			}
			if (currentPosition === 'above' && previousPosition === 'inside') {
				hasTracked.current = true;
				tracking.trackScrollMomentumBar(petitionId);
			}
		},
		[petitionId, tracking],
	);

	return <Waypoint onPositionChange={onPositionChange} />;
};
